/**
 * Hand a blob to the browser as a file download.
 *
 * The CSV routes are admin-authenticated, so the file comes back through the
 * admin service, which attaches the bearer token; a bare link to the same
 * address is a plain navigation carrying no credential. The object URL holds
 * the blob in memory until it is revoked.
 */
export function saveBlob(blob, filename) {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    // Revoked on the next turn rather than in this one. Firefox and Safari
    // cancel a download whose blob URL is revoked before the transfer is
    // handed off, and they cancel it silently.
    setTimeout(() => window.URL.revokeObjectURL(url), 0);
}
